/**
 * @generated SignedSource<<b616053472852581bfc2b3ae3a987ade>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceExampleProjects_productizedService$data = {
  readonly portfolioProjects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceExampleProject_portfolioProject">;
      };
    }>;
  };
  readonly " $fragmentType": "ProductizedServiceExampleProjects_productizedService";
};
export type ProductizedServiceExampleProjects_productizedService$key = {
  readonly " $data"?: ProductizedServiceExampleProjects_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceExampleProjects_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceExampleProjects_productizedService",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        }
      ],
      "concreteType": "ProductizedServicePortfolioProjectConnection",
      "kind": "LinkedField",
      "name": "portfolioProjects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductizedServicePortfolioProjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioProject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProductizedServiceExampleProject_portfolioProject"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "portfolioProjects(first:3)"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "82a3b3a604a416b7f50ae55dd30aec39";

export default node;
